import { memo } from 'react'
import { DropdownButton } from 'react-bootstrap'
import Dropdown from 'react-bootstrap/Dropdown'

import s from './Dropmenu.module.scss'
import './Dropmenu.scss'

import { MoreIcon } from 'assets/icons/MoreIcon'

interface Props {
  show: boolean
  cref: React.RefObject<HTMLDivElement>
  items: {
    icon?: React.ReactNode
    onClick: (e: React.MouseEvent<HTMLElement>) => void
    title: string
    hide?: boolean
  }[]
  variant: 'secondary' | 'primary' | 'outlined' | 'transparent'
  small?: boolean
  title?: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

export const Dropmenu = memo(({ items, cref, show, variant, small, title, style, className }: Props) => {
  return (
    <div
      className={`${s[variant]} ${small ? s.small : ''} ${className}`}
      style={style}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
      }}
    >
      <DropdownButton
        ref={cref}
        show={show}
        title={title ? <span className={s.title}>{title}</span> : <MoreIcon className={s.moreIcon} />}
      >
        <div className={s.menuWrapper}>
          {items.map((item) => {
            if (!item.hide) {
              return (
                <Dropdown.Item
                  className={s.dropdownItem}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation()
                    item.onClick(e)
                  }}
                  key={item.title}
                >
                  <div className={s.iconWrapper}>{item?.icon || null}</div>
                  {item.title}
                </Dropdown.Item>
              )
            } else {
              return null
            }
          })}
        </div>
      </DropdownButton>
    </div>
  )
})
